export default "__VITE_ASSET__IKCfbDoD__"